import * as Immutable from 'immutable';
import {
  GET_DASHBOARDVALUEOVERTIME_ABORTED,
  GET_DASHBOARDVALUEOVERTIME_REQUESTED,
  GET_DASHBOARDVALUEOVERTIME_COMPLETED,
  GET_DASHBOARDVALUEOVERTIME_FAILED,
  RESET_DASHBOARDVALUEOVERTIME_REQUESTED,
  RESET_DASHBOARDVALUEOVERTIME_COMPLETED,
  // RESET_PLAN_ASSETALLOCATION_REQUESTED,
  // RESET_PLAN_ASSETALLOCATION_COMPLETED,
} from '../../actions/dashboardvalueovertime/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: null,
  resettingdata: false,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARDVALUEOVERTIME_ABORTED:
      return state.set('error', null).set('gettingdata', false);

    case GET_DASHBOARDVALUEOVERTIME_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case GET_DASHBOARDVALUEOVERTIME_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_DASHBOARDVALUEOVERTIME_FAILED:
      return state.set('error', action.payload);
    case RESET_DASHBOARDVALUEOVERTIME_REQUESTED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', true)
        .set('gotdata', true);

    case RESET_DASHBOARDVALUEOVERTIME_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', false)
        .set('data', null)
        .set('gotdata', true);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
